export type nudgeType =
  | 'TOP_BANNER' // 상단 배너
  | 'CENTER_BANNER' // 중앙 배너
  | 'BOTTOM_BANNER' // 하단 배너
  | 'MOBILE_BOTTOM'; // 모바일 하단 배너

export enum NUDGE_RS_TYPE {
  TOP_BANNER = 'TOP_BANNER',
  CENTER_BANNER = 'CENTER_BANNER',
  BOTTOM_BANNER = 'BOTTOM_BANNER',
  MOBILE_BOTTOM = 'MOBILE_BOTTOM',
}
